import '../../styles/blocks/_joint-holders.scss';

const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const cryptoJS = require('crypto-js');
import { InformationMessage } from '../informationMessage/informationMessage';
import { FormattedText, formatText } from 'core/i18n';
import { doTagPage } from './tagging';
import { goToErrorsView, setPageName } from 'actions/errorViewNavigation';
import {
    getRecordedAddJointHoldersPage,
    recordedAddJointHoldersPage,
    recordEvent,
    errorTag,
    recordEventStepSuccess,
} from 'utilities/uTagging';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { JointHolders } from 'components/jointHolders/jointHolders';
import { JointHolderAdviseModal } from './jointHolderAdviseModal/jointHolderAdviseModal';
import Headline from 'components/headline';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import jointHoldersActions from 'actions/jointHoldersActions';
import { BROKER } from 'constants/products';
import { ERROR_EN_OTP } from 'constants/analyticsErrors';
import { PATH_CONTACT, PAGE_PRODUCT } from 'constants/uTagConstants/paths';
import { closeDepositWarning } from './utils/closeDepositWarning';

class JointHolder extends React.Component {
    constructor(props) {
        super(props);

        this.onHandlePrevious = this.onHandlePrevious.bind(this);
        this.onHandleContinue = this.onHandleContinue.bind(this);
    }

    onHandlePrevious() {
        const { formActions } = this.props;

        window.scrollTo(0, 0);
        recordedAddJointHoldersPage(false);
        formActions.change('userProfile.isJointHolderAccount', false);
        formActions.change('userProfile.showJointHolder', false);
        formActions.change('userProfile.showOTP', false);
    }

    gotoNextStep() {
        const { actions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        actions.finalizeStep({
            index: currentIndex,
            finished: true,
        });
        actions.enableFinishedAndNextStep();
        actions.changeCurrentStep({
            index: currentIndex + 1,
        });
    }

    checkVerify() {
        const { userProfile, formActions, actions, goToErrorsView } = this.props;
        const accessToken = userProfile.accessToken;
        let jointHoldersError = false;

        actions.clientCardConfigVerify(accessToken, (verifiedOk, errors) => {
            if (verifiedOk) {
                formActions.change('userProfile.showJointHolder', false);
                this.gotoNextStep();
            } else {
                if (errors['6002']) {
                    goToErrorsView({ errorCode: '6002' });
                }
                jointHoldersError = true;
            }
        });

        return {
            jointHoldersError,
        };
    }

    validateJointHolders() {
        const { userProfile, formActions, userProfileForm, immStepsState, jointHoldersActions } = this.props;
        const accessToken = userProfile.accessToken;
        const disabled = immStepsState.get('readOnlyForms');
        let groupValidate = true;
        let jointHoldersError = false;

        userProfile.jointHolderCount.map(id => {
            if (
                !userProfile[`jointholder_${id}_name`] ||
                !userProfile[`jointholder_${id}_lastName`] ||
                (userProfile[`jointholder_${id}_documentType`] === 'DNI' &&
                    !userProfile[`jointholder_${id}_secondLastName`]) ||
                !userProfile[`jointholder_${id}_documentType`] ||
                !userProfile[`jointholder_${id}_docNumber`] ||
                !userProfile[`jointholder_${id}_accountType`] ||
                !userProfile[`jointholder_${id}_email`]
            ) {
                groupValidate = false;
            }
        });

        if (!disabled && userProfileForm.$form.valid && groupValidate) {
            jointHoldersActions.getNewOtp(accessToken, (valid, error) => {
                if (!valid) {
                    errorTag(error.body, PATH_CONTACT, ERROR_EN_OTP, error.statusCode);
                }
            });
            formActions.change('userProfile.showOTP', true);
            formActions.change('userProfile.showJointHolder', false);
        } else {
            formActions.change('userProfile.jointHoldersError', true);
            jointHoldersError = true;
        }

        return jointHoldersError;
    }

    onHandleContinue() {
        const { userProfile, formActions } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        let jointHoldersError = false;

        if (userProfile.jointHolderInvited) {
            jointHoldersError = this.checkVerify();
        } else if (!userProfile.jointHolderAuthorizedList) {
            formActions.change('userProfile.jointHoldersError', true);
            jointHoldersError = true;
        } else {
            jointHoldersError = this.validateJointHolders();
        }

        if (jointHoldersError) {
            recordEvent(
                PATH_CONTACT,
                PAGE_PRODUCT,
                'intervinientes',
                'datos intervinientes incorrecto',
                userProfile.recordId,
                '',
                '',
                userProfile.investmentType,
                docNumberEncrypted
            );
        } else {
            recordEvent(
                PATH_CONTACT,
                PAGE_PRODUCT,
                'intervinientes',
                'datos intervinientes correcto',
                userProfile.recordId,
                '',
                '',
                userProfile.investmentType,
                docNumberEncrypted
            );

            recordEventStepSuccess(
                userProfile.investmentType,
                '/intervinientes/inclusion-intervinientes',
                'anadir intervinientes'
            );
        }
    }

    render() {
        const { userProfile, products, setPageName } = this.props;
        const disclaimer =
            userProfile.promoCode && userProfile.promoCode.toLowerCase() === BROKER
                ? formatText('stepsTitles-jointHolderDataDisclaimerStockAccount')
                : formatText('stepsTitles-jointHolderDataDisclaimer1');

        if (!getRecordedAddJointHoldersPage()) {
            recordedAddJointHoldersPage();
            setPageName(
                doTagPage({
                    userProfile,
                    detalleProducto: products.get('productsDescription'),
                })
            );
        }

        return (
            <>
                <div className="joint-holder__add">
                    <Headline icon="holders" className="prospects-gutter">
                        <h2>
                            <FormattedText value="initial-jointHolderAccount" />
                        </h2>
                    </Headline>
                    <div className="prospects-gutter prospects-separator">
                        <div className="joint-holder__add-disclaimer">{disclaimer}</div>
                        <div className="joint-holder__add-list">
                            <ul>
                                <li>
                                    <FormattedText value="stepsTitles-jointHolderNumbersCondition" />
                                </li>
                                <li>
                                    <FormattedText value="stepsTitles-jointHolderResidentCondition" />
                                </li>
                                <li>
                                    <FormattedText value="stepsTitles-jointHolderDataCondition" />
                                </li>
                            </ul>
                        </div>
                        <InformationMessage text={formatText('stepsTitles-jointHolderDataDisclaimer2')} />
                        <JointHolders limit={4} />
                    </div>
                    <div className="row form__footer">
                        <div className="col-lg-12">
                            <RoadmapNavigation
                                buttonPrevSpecialHidden={false}
                                buttonPrevHidden={true}
                                buttonPrevAction={this.onHandlePrevious}
                                buttonContinueAction={this.onHandleContinue}
                                buttonContinueDisabled={!userProfile.jointHolderAuthorizedList}
                            />
                        </div>
                    </div>
                </div>
                {userProfile.showJointHolderDepositAdvise && (
                    <JointHolderAdviseModal onClickMainAction={() => closeDepositWarning(formActions)} />
                )}
            </>
        );
    }
}

module.exports.constructor = JointHolder;
module.exports.JointHolder = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        setPageName: bindActionCreators(setPageName, dispatch),
    })
)(JointHolder);
